import { Stack } from '@mui/material';

import { FormTextField } from '@/components/form/formTextField';

import type { IntegrationWizardState } from '../integrationWizardFlow';

interface SnowflakeConfigurationProps {
  wizardState: IntegrationWizardState;
  setWizardState: (
    updater: (state: IntegrationWizardState) => IntegrationWizardState
  ) => void;
}

export const SnowflakeConfiguration = ({
  wizardState,
  setWizardState,
}: SnowflakeConfigurationProps) => {
  return (
    <Stack className='w-[582px]' gap='24px'>
      <FormTextField
        title='Account name'
        placeholder='Example: RS543798743'
        value={wizardState.config?.snowflake?.accountName || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              snowflake: {
                accountName: event.target.value,
                warehouse: state.config?.snowflake?.warehouse || '',
                oauth2ClientId: state.config?.snowflake?.oauth2ClientId || '',
              },
            },
          }))
        }
      />
      <FormTextField
        title='Warehouse'
        placeholder='Example: my_warehouse'
        value={wizardState.config?.snowflake?.warehouse || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              snowflake: {
                accountName: state.config?.snowflake?.accountName || '',
                warehouse: event.target.value,
                oauth2ClientId: state.config?.snowflake?.oauth2ClientId || '',
              },
            },
          }))
        }
      />
      <FormTextField
        title='OAuth2 client ID'
        placeholder='Example: 5f69ce7b-0782-4fbc-b546-360babd1e94c'
        value={wizardState.config?.snowflake?.oauth2ClientId || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              snowflake: {
                accountName: state.config?.snowflake?.accountName || '',
                warehouse: state.config?.snowflake?.warehouse || '',
                oauth2ClientId: event.target.value,
              },
            },
          }))
        }
      />
    </Stack>
  );
};
